import { LazyLoadController } from './controllers/LazyLoadController';
import { ScrollController } from './controllers/ScrollController';
import { MenuController } from './controllers/MenuController';
import { TooltipController } from './controllers/TooltipController';
import { ProductSliderController } from './controllers/ProductSliderController';
import { VideoController } from './controllers/VideoController';
import { FormController } from './controllers/FormController';
import { MenuFontController } from './controllers/MenuFontController';
import { MailController } from './controllers/MailController';
import { AgecheckController } from './controllers/AgecheckController';
import { CircleButtonController } from './controllers/CircleButtonController';

window.isHorizontal = false;
window.allowScroll = true;
window.scrollPos = $(window).scrollLeft();
window.circleAnimComplete = true;

window.addEventListener('load', () => {
  $(window).resize((e) => {
    $(window).trigger("window:resize")
  });

  ScrollController();
  MenuController();
  LazyLoadController();
  TooltipController();
  ProductSliderController();
  VideoController();
  FormController();
  MenuFontController();
  MailController();
  AgecheckController();
  CircleButtonController();

  setTimeout(() => {
    $('.loader__container').addClass('hide');

    setTimeout(() => {
      $('.loader__container').addClass('hidden');
    }, 500);
  }, 500)

});



// WEBPACK FOOTER //
// ./src/js/app_shared.js